exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3uWqNhWngLb9bCntvAqgPK{width:12%}._3uWqNhWngLb9bCntvAqgPK,._22GH-Bzy4bVi_zMJApkwUn{display:-webkit-box;display:-ms-flexbox;display:flex}._2Tl1-kxXm-Fako2h9K8egT{width:88%}html[dir] ._3_7VkN1CWrMqOtNeP7nOUf{background:\"[theme:white, default:#ffffff]\"}._3_7VkN1CWrMqOtNeP7nOUf._1UH9Vquj4styaKg5ma-jke,._3_7VkN1CWrMqOtNeP7nOUf._3du_N8R3Naj8IXoRNz_wkf{height:76px}._3_7VkN1CWrMqOtNeP7nOUf._1mDjMscU3O05XB55mF2wbu{height:70px}html[dir] ._2xv3WwXia1wuRLVae9c4jz{padding-top:12px}html[dir] ._4AVA7c3akHPD729RWeaW3._1UH9Vquj4styaKg5ma-jke{padding-top:6px}html[dir] ._4AVA7c3akHPD729RWeaW3._1mDjMscU3O05XB55mF2wbu,html[dir] ._4AVA7c3akHPD729RWeaW3._3du_N8R3Naj8IXoRNz_wkf{padding-top:2px}", ""]);
// Exports
exports.locals = {
	"personaCircle": "_3uWqNhWngLb9bCntvAqgPK",
	"shimmerSecondRow": "_22GH-Bzy4bVi_zMJApkwUn",
	"secondRowText": "_2Tl1-kxXm-Fako2h9K8egT",
	"mailListShimmerContainer": "_3_7VkN1CWrMqOtNeP7nOUf",
	"full": "_1UH9Vquj4styaKg5ma-jke",
	"medium": "_3du_N8R3Naj8IXoRNz_wkf",
	"compact": "_1mDjMscU3O05XB55mF2wbu",
	"paddingFirstMessage": "_2xv3WwXia1wuRLVae9c4jz",
	"paddingMessage": "_4AVA7c3akHPD729RWeaW3"
};